import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css"; // Import des styles par défaut
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import "../styles/Results.css"; // Import des styles personnalisés

// Enregistrement des composants nécessaires pour Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const Results = ({ results, questionsResponses }) => {
  if (!results) {
    return <p>Chargement des résultats...</p>;
  }

  const { score, synthesis, radar, rejection_message } = results;

  // Préparation des données pour le Bar Chart
  const barChartData = {
    labels: radar.map((item) => item.label),
    datasets: [
      {
        label: "Compétences (sur 100)",
        data: radar.map((item) => item.value),
        backgroundColor: "rgba(76, 175, 80, 0.6)", // Vert Leroy Merlin
        borderColor: "rgba(76, 175, 80, 1)",
        borderWidth: 1,
      },
    ],
  };

  const barChartOptions = {
    indexAxis: "y", // Barres horizontales
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        ticks: {
          font: {
            size: 14,
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 14,
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div className="results-container">
      {/* Score global avec barre circulaire */}
      <div className="circular-progress-section">
        <h2>Indice de correspondance</h2>
        <div style={{ width: 150, height: 150, margin: "0 auto" }}>
          <CircularProgressbar
            value={score}
            text={`${score}%`}
            styles={buildStyles({
              textSize: "16px",
              pathColor: `rgba(76, 175, 80, ${score / 100})`, // Change l'opacité en fonction du score
              textColor: "#4caf50", // Couleur du texte
              trailColor: "#d6d6d6", // Couleur de fond
            })}
          />
        </div>
      </div>

      {/* Synthèse */}
      <div className="synthesis-section">
        <h2>Synthèse de la candidature</h2>
        <p>{synthesis}</p>
      </div>

      {/* Message de rejet conditionnel */}
      {rejection_message && (
        <div className="rejection-message-section">
          <h2>Retour sur votre candidature</h2>
          <div className="rejection-message">
            <p>{rejection_message}</p>
          </div>
        </div>
      )}

      {/* Graphique des compétences */}
      <div className="bar-chart-section">
        <h2>Compétences évaluées</h2>
        <div className="bar-chart-container">
          <Bar data={barChartData} options={barChartOptions} />
        </div>
      </div>

      {/* Résumé des questions/réponses */}
      <div className="questions-section">
        <h2>Réponses aux questions</h2>
        <ul className="questions-list">
          {questionsResponses.map((item, index) => (
            <li key={index} className="question-item">
              <strong>Question :</strong> {item.question}
              <br />
              <strong>Réponse :</strong> {item.response}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Results;
